import { Box, Image, Flex, Text } from "@chakra-ui/react";
import React from "react";
import Images from "./Images";

function ReviewCard() {
  return (
    <Box
      borderRadius=".5rem"
      padding="2rem"
      boxShadow="0px 0px 30px 0px rgba(0, 0, 0, 0.05)"
      border="1px solid rgba(0, 0, 0, 0.05)"
      maxWidth="450px"
      display="inline-block"
      bg="white"
      m="1rem"
    >
      <Text whiteSpace="normal" mb="2rem">
        This is the best! I’m enjoying how my wishes get fulfilled without
        stress. This workes like magic. I’ve bookmarked this website. I’m gonna
        refer all my family and friends!
      </Text>
      <Flex align="center">
        <Image width="70px" height="70px" src={Images.Person7} alt="person" />
        <Box>
          <Text fontWeight="bold">Samuel</Text>
          <Text>from Lagos</Text>
        </Box>
      </Flex>
    </Box>
  );
}

export default ReviewCard;
